module.exports = __webpack_public_path__ + "static/paella-3948d840639f053c0dcc39ef1c3c27a5.jpg";